// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  firebase: {
    apiKey: "AIzaSyC36DaesBEJmHwwX4tb_xm3zO9Ygw38xUQ",
    authDomain: "zpln-staging.firebaseapp.com",
    databaseURL: "https://zpln-staging-default-rtdb.firebaseio.com",
    projectId: "zpln-staging",
    storageBucket: "zpln-staging.appspot.com",
    messagingSenderId: "711925365378",
    appId: "1:711925365378:web:eb4765b2a7f8bb745a929b",
    measurementId: "G-RR0HW9B8X5"
  },
  production: false
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
